import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '@/utils/configUtil'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: config().VUE_APP_I18N_LOCALE || 'pt-PT',
  fallbackLocale: config().VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
  messages: loadLocaleMessages(),
  //https://github.com/kazupon/vue-i18n/issues/201
  silentTranslationWarn: process.env.NODE_ENV === 'production',
})
